import { createScopedLogger } from "@@common";

export type NavigateFunction = (path: string) => void;

const logger = createScopedLogger("NavigationService");

export class NavigationService {
  static readonly KEY = "NavigationService";

  private _navigate: NavigateFunction = () => {
    logger.warn("Navigate function not set yet.");
  };

  setNavigate(fn: NavigateFunction): void {
    this._navigate = fn;
  }

  navigate(path: string): void {
    this._navigate(path);
  }
}

/**
 * Fills in route path params (e.g. `/view/:id`) from the given input object.
 * Any input keys that don't match a path segment become query string params.
 */
export function buildRoutePath(routePath: string, params?: Record<string, any>): string {
  if (!params) return routePath;

  const usedKeys = new Set<string>();
  const filledPath = routePath.replace(/:([^/]+)/g, (_, key) => {
    usedKeys.add(key);
    return params[key] !== undefined ? encodeURIComponent(String(params[key])) : `:${key}`;
  });

  const remaining = Object.entries(params).filter(([k]) => !usedKeys.has(k) && params[k] !== undefined);
  if (remaining.length === 0) return filledPath;

  const query = new URLSearchParams(remaining.map(([k, v]) => [k, String(v)])).toString();
  return `${filledPath}?${query}`;
}
